// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleRecircFooter_root__3gNM6","main":"ArticleRecircFooter_main__FYLYO","rightRail":"ArticleRecircFooter_rightRail__NKGKE"};